import TherapyCard from './TherapyCard'
import { Link } from 'react-router-dom'

export default function TherapyTypes() {
  return (
    <div className="w-screen flex justify-center py-16 md:py-32">
      <div className="w-full px-4 md:px-8 max-w-[1280px]">
        <div className="relative">
          <div className="grid grid-cols-1 lg:grid-cols-[400px,1fr] gap-8 md:gap-16">
            
            {/* Sticky content */}
            <div className="lg:sticky lg:top-24 h-max">
              <div className="flex flex-col items-start">
                <h2 className="headline-large mb-6">Terapia Física</h2>
                <p className="text-xl text-gray-600">
                El alcance de la mayor independencia posible. Te mostramos algunas de nuestras técnicas usadas en la escuela.
                </p>
              </div>
            </div>

            {/* Cards stack */}
            <div className="flex flex-col gap-8 w-full md:max-w-[75%] md:ml-auto">
              <TherapyCard
                icon={
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5" />
                  </svg>
                }
                title="Manual"
                description="Movimiento pasivo en la articulación para mejorar la movilidad y tratar con el dolor."
                image="/images/banners/manual_gaviota.jpg"
              />
              <TherapyCard
                icon={
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                }
                title="Estimulación"
                description="Técnicas de estimulación sensorial y motora para mejorar el desarrollo y la función neurológica."
                image="/images/banners/estim_gaviota.jpg"
              />
              
              <Link 
                to="/informe" 
                className="w-full text-center px-8 py-3 rounded-[50px] text-black hover:text-black hover:border hover:border-[#1a1a1a] transition-all duration-300 no-underline"
              >
                Ver el informe completo →
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
} 